import { Badge } from '@/components/ui/badge';

const statusStyles = {
  // Lead statuses
  new: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  contacted: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
  qualified: 'bg-purple-100 text-purple-800 hover:bg-purple-100',
  converted: 'bg-green-100 text-green-800 hover:bg-green-100',
  lost: 'bg-gray-100 text-gray-600 hover:bg-gray-100',
  
  // Case statuses
  open: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  in_progress: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  pending: 'bg-orange-100 text-orange-800 hover:bg-orange-100',
  completed: 'bg-green-100 text-green-800 hover:bg-green-100',
  closed: 'bg-gray-100 text-gray-600 hover:bg-gray-100',
  
  // Claim statuses
  submitted: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  under_review: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  approved: 'bg-green-100 text-green-800 hover:bg-green-100',
  rejected: 'bg-red-100 text-red-800 hover:bg-red-100',
  settled: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-100',
  
  // Quote/Report statuses
  draft: 'bg-gray-100 text-gray-600 hover:bg-gray-100',
  sent: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  accepted: 'bg-green-100 text-green-800 hover:bg-green-100',
  expired: 'bg-red-100 text-red-800 hover:bg-red-100',
  pending_review: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
};

const priorityStyles = {
  low: 'bg-gray-100 text-gray-600 hover:bg-gray-100',
  medium: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  high: 'bg-orange-100 text-orange-800 hover:bg-orange-100',
  urgent: 'bg-red-100 text-red-800 hover:bg-red-100',
};

export function StatusBadge({ status, className = '' }) {
  const style = statusStyles[status] || 'bg-gray-100 text-gray-600';
  const displayText = status?.replace(/_/g, ' ') || 'Unknown';
  
  return (
    <Badge className={`${style} capitalize font-medium text-xs ${className}`} variant="secondary">
      {displayText}
    </Badge>
  );
}

export function PriorityBadge({ priority, className = '' }) {
  const style = priorityStyles[priority] || 'bg-gray-100 text-gray-600';
  
  return (
    <Badge className={`${style} capitalize font-medium text-xs ${className}`} variant="secondary">
      {priority}
    </Badge>
  );
}
